module.exports = __webpack_public_path__ + "media/video.ed2b2760.mp4";